import React, { useState } from "react";
import prathamLogo from "../../../assets/images/health-insurance/svg/pratham-logo.png";
import uttamLogo from "../../../assets/images/health-insurance/svg/uttam-logo.png";
import paramLogo from "../../../assets/images/health-insurance/svg/param-logo.png";
import checkSvg from "../../../assets/images/health-insurance/svg/check.svg";
import lineSvg from "../../../assets/images/health-insurance/svg/line.svg";
import minusSvg from "../../../assets/images/health-insurance/svg/minus.svg";
import plusSvg from "../../../assets/images/health-insurance/svg/plus.svg";
import downloadSvg from "../../../assets/images/health-insurance/svg/download.svg";
import mchiSarvahPdf from "../../../assets/pdf/mchi-sarvaha.pdf";

const HealthInsuranceMobile = ({ link }) => {
  const [activeParentTab, setActiveParentTab] = useState("pratham");
  const [activeChildTab, setActiveChildTab] = useState("");

  const toggleChildTab = (tabName) => {
    setActiveChildTab((prevTab) => (prevTab === tabName ? "" : tabName));
  };

  return (
    <div className="block lg:hidden px-6 lg:px-[120px] pb-20 lg:pb-[120px] w-full">
      {/* Header */}
      <div className="flex flex-col">
        <div className="flex space-x-4">
          <button
            className={`px-5 py-4 text-base rounded-full ${
              activeParentTab === "pratham"
                ? "bg-[#0B497A] text-white"
                : "bg-white text-[#C6C6C6] border border-[#C6C6C6] hover:bg-white hover:text-[#0B497A] hover:border-[#0B497A]"
            }`}
            onClick={() => setActiveParentTab("pratham")}
          >
            Pratham
          </button>
          <button
            className={`px-5 py-4 text-base rounded-full ${
              activeParentTab === "uttam"
                ? "bg-[#0B497A] text-white"
                : "bg-white text-[#C6C6C6] border border-[#C6C6C6] hover:bg-white hover:text-[#0B497A] hover:border-[#0B497A]"
            }`}
            onClick={() => setActiveParentTab("uttam")}
          >
            Uttam
          </button>
          <button
            className={`px-5 py-4 text-base rounded-full ${
              activeParentTab === "param"
                ? "bg-[#0B497A] text-white"
                : "bg-white text-[#C6C6C6] border border-[#C6C6C6] hover:bg-white hover:text-[#0B497A] hover:border-[#0B497A]"
            }`}
            onClick={() => setActiveParentTab("param")}
          >
            Param
          </button>
        </div>
        {activeParentTab === "pratham" && (
          <p className="text-black text-base leading-6 opacity-70 pt-8">
            Sarvah Pratham Health Insurance we resonate your commitment to your
            family’s health and well-being.
          </p>
        )}
        {activeParentTab === "uttam" && (
          <p className="text-black text-base leading-6 opacity-70 pt-8">
            Sarvah Uttam Health Insurance we resonate your commitment to your
            family’s health and well-being.
          </p>
        )}
        {activeParentTab === "param" && (
          <p className="text-black text-base leading-6 opacity-70 pt-8">
            Sarvah Param Health Insurance we resonate your commitment to your
            family’s health and well-being.
          </p>
        )}
        {activeParentTab === "pratham" && (
          <div className="bg-[#F7F7F7] rounded-[32px] mt-6">
            <div className="p-8">
              <img
                src={prathamLogo}
                alt="pratham-logo"
                className="mb-3 max-w-[100px]"
              />
              <div className="text-black">
                <p className="text-2xl font-bold">₹367*/yr.</p>
                <p className="text-base">Base Premium </p>
              </div>
              <div className="text-black mt-8 mb-4 flex flex-col gap-4">
                <div className="flex flex-row item-center gap-1 w-full">
                  <p className="text-base opacity-70">Sum Insured</p>
                  <div className="grow bg-line-svg bg-repeat-x bg-center" />
                  <p className="font-bold opacity-100">₹5L - ₹3C</p>
                </div>
                <div className="flex flex-row item-center gap-1 w-full">
                  <p className="text-base opacity-70">PED Waiting Period</p>
                  <div className="grow bg-line-svg bg-repeat-x bg-center" />
                  <p className="font-bold opacity-100">36 mo.</p>
                </div>
              </div>
              <div className="h-[1px] w-full bg-black opacity-40" />
              <ul className="mt-4 flex flex-col gap-2 max-h-[240px] overflow-y-auto no-scrollbar">
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Hospitalization coverage up to ₹3 Cr for Heart, Cancer,
                    Stroke and major organ/bone marrow transplant.
                  </p>
                </li>
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    With Sarathi, get your waiting period reduced to 30 days
                    even if you have Pre-Existing diseases such as Asthma,
                    Diabetes, Dyslipidemia, Obesity, Hypertension.
                  </p>
                </li>
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Unlimited Restoration is available within the policy year,
                    whether for unrelated or the same condition.
                  </p>
                </li>
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    With Surplus Benefits, get an additional 100% of your Sum
                    Insured from Day 1 for the first claim in each policy.
                  </p>
                </li>
              </ul>
              <button
                onClick={() => (window.location.href = link)}
                href={link}
                className="bg-[#FB7C2F] w-full text-xl rounded-xl text-white py-4 mt-8"
              >
                Get Quote
              </button>
            </div>
          </div>
        )}
        {activeParentTab === "uttam" && (
          <div className="bg-[#F7F7F7] rounded-[32px] mt-6">
            <div className="p-8">
              <img
                src={uttamLogo}
                alt="uttam-logo"
                className="mb-3 max-w-[100px]"
              />
              <div className="text-black">
                <p className="text-2xl font-bold">₹4,103*/yr.</p>
                <p className="text-base">Base Premium </p>
              </div>
              <div className="text-black mt-8 mb-4 flex flex-col gap-4">
                <div className="flex flex-row item-center gap-1 w-full">
                  <p className="text-base opacity-70">Sum Insured</p>
                  <div className="grow bg-line-svg bg-repeat-x bg-center" />
                  <p className="font-bold opacity-100">₹5L - ₹3C</p>
                </div>
                <div className="flex flex-row item-center gap-1 w-full">
                  <p className="text-base opacity-70">PED Waiting Period</p>
                  <div className="grow bg-line-svg bg-repeat-x bg-center" />
                  <p className="font-bold opacity-100">36 mo.</p>
                </div>
              </div>
              <div className="h-[1px] w-full bg-black opacity-40" />
              <ul className="mt-4 flex flex-col gap-2 max-h-[240px] overflow-y-auto no-scrollbar">
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Get infinite sum Insured for hospitalization related to
                    Heart, Cancer, Stroke and organ/bone marrow transplant.
                  </p>
                </li>
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Unlimited Restoration is available within the policy year,
                    whether for unrelated or the same condition.
                  </p>
                </li>
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Shield your family with a comprehensive Personal Accident
                    Cover up to Rs 3 Cr.
                  </p>
                </li>
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Gullak benefits guarantees up to 15X bonus over the base Sum
                    Insured, irrespective of claim (100% increase in the Sum
                    Insured each policy year, up to maximum of 1500%).
                  </p>
                </li>
              </ul>
              <button
                onClick={() => (window.location.href = link)}
                className="bg-[#FB7C2F] w-full text-xl rounded-xl text-white py-4 mt-8"
              >
                Get Quote
              </button>
            </div>
          </div>
        )}
        {activeParentTab === "param" && (
          <div className="bg-[#F7F7F7] rounded-[32px] mt-6">
            <div className="p-8">
              <img
                src={paramLogo}
                alt="param-logo"
                className="mb-3 max-w-[100px]"
              />
              <div className="text-black">
                <p className="text-2xl font-bold">₹6,498*/yr.</p>
                <p className="text-base">Base Premium </p>
              </div>
              <div className="text-black mt-8 mb-4 flex flex-col gap-4">
                <div className="flex flex-row item-center gap-1 w-full">
                  <p className="text-base opacity-70">Sum Insured</p>
                  <div className="grow bg-line-svg bg-repeat-x bg-center" />
                  <p className="font-bold opacity-100">₹5L - ₹3C</p>
                </div>
                <div className="flex flex-row item-center gap-1 w-full">
                  <p className="text-base opacity-70">PED Waiting Period</p>
                  <div className="grow bg-line-svg bg-repeat-x bg-center" />
                  <p className="font-bold opacity-100">36 mo.</p>
                </div>
              </div>
              <div className="h-[1px] w-full bg-black opacity-40" />
              <ul className="mt-4 flex flex-col gap-2 max-h-[240px] overflow-y-auto no-scrollbar">
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Tatkal Benefit ensures you have absolutely zero waiting
                    period.
                  </p>
                </li>
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Unlimited Restoration is available within the policy year,
                    whether for unrelated or the same condition.
                  </p>
                </li>
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Shield your family with a comprehensive Personal Accident
                    Cover up to Rs 3 Cr.
                  </p>
                </li>
                <li className="flex gap-4 items-start">
                  <img src={checkSvg} alt="check" />
                  <p className="text-black text-base leading-[26px] opacity-70">
                    Gullak benefits guarantees up to 15X bonus over the base Sum
                    Insured, irrespective of claim (100% increase in the Sum
                    Insured each policy year, up to maximum of 1500%)
                  </p>
                </li>
              </ul>
              <button
                onClick={() => (window.location.href = link)}
                className="bg-[#FB7C2F] w-full text-xl rounded-xl text-white py-4 mt-8"
              >
                Get Quote
              </button>
            </div>
          </div>
        )}
        <div className="flex flex-col">
          {/* Child Tabs */}
          {activeParentTab === "pratham" && (
            <div className="mt-8">
              <button
                className={`w-full pb-6 flex flex-row justify-between items-center ${
                  activeChildTab === "benefits"
                    ? " text-[#27506E]"
                    : "text-[#181818] hover:text-[#27506E]"
                }`}
                onClick={() => toggleChildTab("benefits")}
              >
                Benefits
                {activeChildTab === "benefits" ? (
                  <img src={minusSvg} alt="minus" />
                ) : (
                  <img src={plusSvg} alt="plus" />
                )}
              </button>
              {activeChildTab === "benefits" ? (
                ""
              ) : (
                <div className="h-[1px] w-full bg-black opacity-40" />
              )}
              {/* Child Tab Content */}
              <div className="mt-6 flex flex-col gap-5">
                {activeChildTab === "benefits" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Hospitalization coverage up to Rs3 Cr for Heart,
                            Cancer, Stroke and major organ/bone marrow
                            transplant.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            With Sarathi, get your waiting period reduced to 30
                            days even if you have Pre-Existing diseases such as
                            Asthma, Diabetes, Dyslipidemia, Obesity,
                            Hypertension.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Unlimited Restoration is available within the policy
                            year, whether for unrelated or the same condition.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            With Surplus Benefits, get an additional 100% of
                            your Sum Insured from Day 1 for the first claim in
                            each policy
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            No zonal co-pay worries ensuring faster recovery in
                            the city of your choice Without Worrying about
                            Additional Co-Payment.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Without Worrying About Additional financial burden
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Enjoy Discount And Saving Via First Policy
                            Anniversary (5% Discount) And Get A 2.5% Discount On
                            The Renewal Premium When You Renew Your Policy 30
                            Days Prior To Expiry
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "inclusions"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("inclusions")}
                >
                  Inclusions
                  {activeChildTab === "inclusions" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "inclusions" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "inclusions" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Hospitalization Expenses for Heart, Cancer, Stroke
                            and major organ/bone marrow transplant.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Pre & Post Hospitalization Medical Expenses of 90
                            And 180 days respectively.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Domiciliary Hospitalization up to Sum Insured.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Road Ambulance up to Sum Insured.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Donor expenses up to Sum Insured.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            AYUSH treatment up to Sum Insured.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Unlimited Tele-Consultation with General Physician.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Wellness Program – Earn rewards up to 20% of base
                            premium (excluding premium for optional covers other
                            than Deductible, Voluntary Co-payment, Twin Sharing
                            under Room Rent Modification, riders and taxes)
                            through Healthy Life Management Program.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Discount On Pharmacy, Diagnostics And Health
                            Supplements, offered by the Network Providers of
                            MCHI.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "exclusions"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("exclusions")}
                >
                  Exclusions
                  {activeChildTab === "exclusions" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "exclusions" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "exclusions" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Breach of law
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Contamination from nuclear fuel or radiation
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Hazardous or adventure sports
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Foreign invasion or civil war
                          </p>
                        </li>
                      </ul>
                      <p className="text-black text-sm leading-[22px]">
                        Above List is only indicative and not exhaustive. For
                        complete details on Eligibility, Coverages, Benefits,
                        Terms, Condition and Exclusions please refer Policy
                        Wordings and Prospectus
                      </p>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "addOns"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("addOns")}
                >
                  Add ons & Options
                  {activeChildTab === "addOns" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "addOns" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "addOns" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Accident Hospitalization Cover
                            <br />
                            <span className="font-normal">
                              Coverage for Accidental hospitalization if the
                              insured person suffers an injury due to an
                              accident
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Temporary Total Disablement
                            <br />
                            <span className="font-normal">
                              Get a Fixed Weekly benefit up to Rs 1 Lacs per
                              Week
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Personal Accident Cover
                            <br />
                            <span className="font-normal">
                              Get up to Rs 3cr Cover for Accidental Death (AD)
                              and Permanent Total or Partial Disability (PTD &
                              PPD). Coverage of 200% of opted Sum Insured (If
                              AD/PTD) occurs due to an Accident while travelling
                              as a fare paying passenger on a common carrier.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Health Check up
                            <br />
                            <span className="font-normal">
                              Available from 1st Year onwards, to all adult
                              Insured Persons who have completed 18 Years of
                              age.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Restoration of Sum Insured
                            <br />
                            <span className="font-normal">
                              Refill your policy with Multiple Restoration is
                              available in a Policy Year for all illnesses,
                              whether unrelated or same
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Air Ambulance
                            <br />
                            <span className="font-normal">
                              Avail the Air Ambulance cover up to Sum Insured,
                              subject to a maximum of ₹ 10Lacs, over and above
                              the sum Insured.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Gullak (Guaranteed Cumulative Bonus)
                            <br />
                            <span className="font-normal">
                              100% Guaranteed Increase in Sum Insured in each
                              Policy Year, maximum up to 1500% Irrespective of a
                              claim under the policy
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Sarathi
                            <br />
                            <span className="font-normal">
                              Waive-off the waiting period for pre-existing
                              condition like Asthma, Diabetes, Dyslipidemia,
                              Obesity and Hypertension.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Room Rent Modification
                            <br />
                            <span className="font-normal">
                              Freedom to choose Any Room or Twin Sharing AC room
                              category as per your requirement
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Surplus Benefit
                            <br />
                            <span className="font-normal">
                              Get an additional 100% of the sum insured
                              available from day 1 for 1st claim only, in each
                              policy year.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Cover Non-Medical Items and Durable medical
                            equipment's
                            <br />
                            <span className="font-normal">
                              Get coverage for non-medical items and durable
                              medical equipment’s which is otherwise an out of
                              pocket expense during hospitalization
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Deductible option
                            <br />
                            <span className="font-normal">
                              Aggregate deductible or Daily Deductible option
                              available basis the requirement
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Voluntary Co-payment
                            <br />
                            <span className="font-normal">
                              Cost sharing percentage that you have opted will
                              apply on each and every claim
                            </span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "eligibility"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("eligibility")}
                >
                  Eligibility
                  {activeChildTab === "eligibility" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "eligibility" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "eligibility" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Min Entry Age
                            <br />
                            <span className="font-normal">
                              Child - 91 days, Adult - 18 years
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Cover Type
                            <br />
                            <span className="font-normal">
                              Individual/Multi-individual and family floater
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Max Entry Age
                            <br />
                            <span className="font-normal">
                              No Limit (Dependent Children up to the age of 30
                              years can be covered under the family floater
                              plan)
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Policy Period
                            <br />
                            <span className="font-normal">
                              1, 2 and 3 years
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Relationships covered
                            <br />
                            <span className="font-normal">
                              Self, Spouse, Live-in partner, Children, Father,
                              Mother, Father-in-law, Mother-in-law, Son-in-law,
                              Daughter-in-law, Grand-parents, Grandchildren,
                              Uncle, Aunt, Nephew, Niece, Brother, Sister,
                              Sister in-law, Brother in-law
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Premium Payment Mode
                            <br />
                            <span className="font-normal">
                              Single, Half yearly, Quarterly, Monthly.
                            </span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {activeParentTab === "uttam" && (
            <div className="mt-8">
              <button
                className={`w-full pb-6 flex flex-row justify-between items-center ${
                  activeChildTab === "benefits"
                    ? " text-[#27506E]"
                    : "text-[#181818] hover:text-[#27506E]"
                }`}
                onClick={() => toggleChildTab("benefits")}
              >
                Benefits
                {activeChildTab === "benefits" ? (
                  <img src={minusSvg} alt="minus" />
                ) : (
                  <img src={plusSvg} alt="plus" />
                )}
              </button>
              {activeChildTab === "benefits" ? (
                ""
              ) : (
                <div className="h-[1px] w-full bg-black opacity-40" />
              )}
              {/* Child Tab Content */}
              <div className="mt-6 flex flex-col gap-5">
                {activeChildTab === "benefits" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Get infinite sum Insured for hospitalization related
                            to Heart, Cancer, Stroke and organ/bone marrow
                            transplant.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Gullak benefits guarantees up to 15X bonus over the
                            base Sum Insured, irrespective of claim (100%
                            increase in the Sum Insured each policy year, up to
                            maximum of 1500%).
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            With Sarathi, get your waiting period reduced to 30
                            days even if you have Pre-Existing diseases such as
                            Asthma, Diabetes, Dyslipidemia, Obesity,
                            Hypertension.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Unlimited Restoration is available within the policy
                            year, whether for unrelated or the same condition.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Shield your family with a comprehensive Personal
                            Accident Cover up to Rs 3 Cr.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            With Surplus Benefit get an additional 100% of your
                            Sum Insured from Day 1 for the first claim in each
                            policy.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Get up to 7.5% discounts on your 1st policy renewal
                            premium if the Policy is renewed 30 days before the
                            Policy expiry date.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            No Zonal Co-Payment, if treatment taken at higher
                            zone
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "inclusions"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("inclusions")}
                >
                  Inclusions
                  {activeChildTab === "inclusions" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "inclusions" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "inclusions" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Hospitalization Expenses for Heart, Cancer, Stroke
                            and major organ/bone marrow transplant.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Pre & Post Hospitalization Medical Expenses of 90
                            And 180 days respectively.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Domiciliary Hospitalization up to Sum Insured.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Road Ambulance up to Sum Insured.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Donor expenses up to Sum Insured.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            AYUSH treatment up to Sum Insured.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Unlimited Tele-Consultation with General Physician.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Wellness Program – Earn rewards up to 20% of base
                            premium (excluding premium for optional covers other
                            than Deductible, Voluntary Co-payment, Twin Sharing
                            under Room Rent Modification, riders and taxes)
                            through Healthy Life Management Program.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Discount On Pharmacy, Diagnostics And Health
                            Supplements, offered by the Network Providers of
                            MCHI.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "exclusions"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("exclusions")}
                >
                  Exclusions
                  {activeChildTab === "exclusions" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "exclusions" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "exclusions" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Breach of law
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Contamination from nuclear fuel or radiation
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Hazardous or adventure sports
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Foreign invasion or civil war
                          </p>
                        </li>
                      </ul>
                      <p className="text-black text-sm leading-[22px]">
                        Above List is only indicative and not exhaustive. For
                        complete details on Eligibility, Coverages, Benefits,
                        Terms, Condition and Exclusions please refer Policy
                        Wordings and Prospectus
                      </p>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "addOns"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("addOns")}
                >
                  Add ons & Options
                  {activeChildTab === "addOns" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "addOns" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "addOns" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Personal Accident Cover
                            <br />
                            <span className="font-normal">
                              Get up to Rs 3cr Cover for Accidental Death (AD)
                              and Permanent Total or Partial Disability (PTD &
                              PPD). Coverage of 200% of opted Sum Insured (If
                              AD/PTD) occurs due to an Accident while travelling
                              as a fare paying passenger on a common carrier.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Temporary Total Disablement
                            <br />
                            <span className="font-normal">
                              Get a Fixed Weekly benefit up to Rs 1 Lacs per
                              Week
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Health Check up
                            <br />
                            <span className="font-normal">
                              Available from 1st Year onwards, to all adult
                              Insured Persons who have completed 18 Years of
                              age.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Air Ambulance
                            <br />
                            <span className="font-normal">
                              Avail the Air Ambulance cover up to Sum Insured,
                              subject to a maximum of ₹ 10Lacs, over and above
                              the sum Insured.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Restoration of Sum Insured
                            <br />
                            <span className="font-normal">
                              Refill your policy with Multiple Restoration
                              available In a Policy Year for all illnesses,
                              whether unrelated or same
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Gullak (Guaranteed Cumulative Bonus)
                            <br />
                            <span className="font-normal">
                              100% Guaranteed Increase in Sum Insured in each
                              Policy Year, maximum up to 1500% Irrespective of a
                              claim under the policy
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Maternity and New born Cover
                            <br />
                            <span className="font-normal">
                              We make you future-proof with Maternity and New
                              Born coverage up to 20% of the base Sum Insured or
                              up to Rs 5L. Focus on your family growth without
                              worrying about medical expense.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Anant (Unlimited Sum Insured)
                            <br />
                            <span className="font-normal">
                              Get infinite sum Insured for hospitalization
                              related to Heart, Cancer, Stroke and organ/bone
                              marrow transplant
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Sarathi
                            <br />
                            <span className="font-normal">
                              Waive-off the waiting period for pre-existing
                              condition like Asthma, Diabetes, Dyslipidaemia,
                              Obesity and Hypertension.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Room Rent Modification
                            <br />
                            <span className="font-normal">
                              Freedom to choose Any Room or Twin Sharing AC room
                              category as per your requirement
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Surplus Benefit
                            <br />
                            <span className="font-normal">
                              Get an additional 100% of the sum insured
                              available from day 1 for 1st claim only, in each
                              policy year.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Coverage for Non-Medical Items And Durable Medical
                            Equipment’s
                            <br />
                            <span className="font-normal">
                              Get coverage for non-medical items and durable
                              medical equipment’s which is otherwise an out of
                              pocket expense during hospitalization
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Deductible Option
                            <br />
                            <span className="font-normal">
                              Aggregate deductible or Daily Deductible option
                              available basis the requirement
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Voluntary Co-Payment
                            <br />
                            <span className="font-normal">
                              Cost sharing percentage that you have opted will
                              apply on each and every claim
                            </span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "eligibility"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("eligibility")}
                >
                  Eligibility
                  {activeChildTab === "eligibility" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "eligibility" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "eligibility" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Min Entry Age
                            <br />
                            <span className="font-normal">
                              Child - 91 days, Adult - 18 years
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Cover Type
                            <br />
                            <span className="font-normal">
                              Individual/Multi-individual and family floater
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Max Entry Age
                            <br />
                            <span className="font-normal">
                              No Limit (Dependent Children up to the age of 30
                              years can be covered under the family floater
                              plan)
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Policy Period
                            <br />
                            <span className="font-normal">
                              1, 2 and 3 years
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Relationships covered
                            <br />
                            <span className="font-normal">
                              Self, Spouse, Live-in partner, Children, Father,
                              Mother, Father-in-law, Mother-in-law, Son-in-law,
                              Daughter-in-law, Grand-parents, Grandchildren,
                              Uncle, Aunt, Nephew, Niece, Brother, Sister,
                              Sister in-law, Brother in-law
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Premium Payment Mode
                            <br />
                            <span className="font-normal">
                              Single, Half yearly, Quarterly, Monthly.
                            </span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {activeParentTab === "param" && (
            <div className="mt-8">
              <button
                className={`w-full pb-6 flex flex-row justify-between items-center ${
                  activeChildTab === "benefits"
                    ? " text-[#27506E]"
                    : "text-[#181818] hover:text-[#27506E]"
                }`}
                onClick={() => toggleChildTab("benefits")}
              >
                Benefits
                {activeChildTab === "benefits" ? (
                  <img src={minusSvg} alt="minus" />
                ) : (
                  <img src={plusSvg} alt="plus" />
                )}
              </button>
              {activeChildTab === "benefits" ? (
                ""
              ) : (
                <div className="h-[1px] w-full bg-black opacity-40" />
              )}
              {/* Child Tab Content */}
              <div className="mt-6 flex flex-col gap-5">
                {activeChildTab === "benefits" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Tatkal Benefit ensures you have absolutely zero
                            waiting period.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            With Sarathi, get your waiting period reduced to 30
                            days even if you have Pre-Existing diseases such as
                            Asthma, Diabetes, Dyslipidemia, Obesity,
                            Hypertension.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Unlimited Restoration is available within the policy
                            year, whether for unrelated or the same condition.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Gullak benefits guarantees up to 15X bonus over the
                            base Sum Insured, irrespective of claim (100%
                            increase in the Sum Insured each policy year, up to
                            maximum of 1500%).
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Shield your family with a comprehensive Personal
                            Accident Cover up to Rs 3 Cr.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            With Surplus Benefit get an additional 100% of your
                            Sum Insured from Day 1 for the first claim in each
                            policy.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            No Zonal Co-Payment, if treatment taken at higher
                            zone.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Get up to 2.5% discounts on your 1st policy renewal
                            premium if the Policy renewed 30 in advance and earn
                            20% rewards of base premium* through completing
                            Healthy Life Management Program
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "inclusions"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("inclusions")}
                >
                  Inclusions
                  {activeChildTab === "inclusions" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "inclusions" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "inclusions" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Hospitalization Expenses for any illness or disease
                            or injury
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Pre & Post Hospitalization Medical Expenses of 90
                            And 180 days respectively
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Domiciliary Hospitalization up to Sum Insured
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Road Ambulance up to Sum Insured
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Donor expenses up to Sum Insured
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Restoration Of Sum Insured-
                            <br />
                            <span className="font-normal">
                              Refill your policy with Multiple Restoration
                              available In a Policy Year for all illnesses,
                              whether unrelated or same
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Health Check up available from 1st year onwards, to
                            all adult insured persons who have completed 18
                            years of age
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            AYUSH treatment up to Sum Insured.
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Gullak (Guaranteed Cumulative Bonus)-
                            <br />
                            <span className="font-normal">
                              100% Guaranteed Increase in Sum Insured in each
                              Policy Year, maximum up to 1500% Irrespective of a
                              claim under the policy
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Unlimited Tele-Consultation with General Physician
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Wellness Program –<br />
                            <span className="font-normal">
                              Earn rewards up to 20% of base premium (excluding
                              premium for optional covers other than Deductible,
                              Voluntary Co-payment, Twin Sharing under Room Rent
                              Modification, Pratiksha, riders and taxes) through
                              Healthy Life Management Program
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Discount On Pharmacy, Diagnostics And Health
                            Supplements, offered by the Network Providers of
                            MCHI
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Health Check Up-
                            <br />
                            <span className="font-normal">
                              Available from 1st Year onwards, to all adult
                              Insured Persons who have completed 18 Years of
                              age.
                            </span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "exclusions"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("exclusions")}
                >
                  Exclusions
                  {activeChildTab === "exclusions" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "exclusions" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "exclusions" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Breach of law
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Contamination from nuclear fuel or radiation
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Hazardous or adventure sports
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black text-sm leading-[22px]">
                            Foreign invasion or civil war
                          </p>
                        </li>
                      </ul>
                      <p className="text-black text-sm leading-[22px]">
                        Above List is only indicative and not exhaustive. For
                        complete details on Eligibility, Coverages, Benefits,
                        Terms, Condition and Exclusions please refer Policy
                        Wordings and Prospectus
                      </p>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "addOns"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("addOns")}
                >
                  Add ons & Options
                  {activeChildTab === "addOns" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "addOns" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "addOns" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Personal Accident Cover
                            <br />
                            <span className="font-normal">
                              Get up to Rs 3cr Cover for Accidental Death (AD)
                              and Permanent Total or Partial Disability (PTD &
                              PPD). Coverage of 200% of opted Sum Insured (If
                              AD/PTD) occurs due to an Accident while travelling
                              as a fare paying passenger on a common carrier.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Temporary Total Disablement
                            <br />
                            <span className="font-normal">
                              Get a Fixed Weekly benefit up to Rs 1 Lacs per
                              Week
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Room Rent Modification
                            <br />
                            <span className="font-normal">
                              Freedom to choose Any Room or Twin Sharing AC room
                              category as per your requirement
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Air Ambulance
                            <br />
                            <span className="font-normal">
                              Avail the Air Ambulance cover up to Sum Insured,
                              subject to a maximum of ₹ 10Lacs, over and above
                              the sum Insured.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Sarathi
                            <br />
                            <span className="font-normal">
                              Waive-off the waiting period for pre-existing
                              condition like Asthma, Diabetes, Dyslipidemia,
                              Obesity and Hypertension.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Surplus Benefit
                            <br />
                            <span className="font-normal">
                              Get an additional 100% of the sum insured
                              available from day 1 for 1st claim only, in each
                              policy year.
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Cover Non-Medical Items and Durable medical
                            equipment's
                            <br />
                            <span className="font-normal">
                              Get coverage for non-medical items and durable
                              medical equipment’s which is otherwise an out of
                              pocket expense during hospitalization
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Deductible option
                            <br />
                            <span className="font-normal">
                              Aggregate deductible or Daily Deductible option
                              available basis the requirement
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Voluntary Co-payment
                            <br />
                            <span className="font-normal">
                              Cost sharing percentage that you have opted will
                              apply on each and every claim
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Pratiksha
                            <br />
                            <span className="font-normal">
                              Specific Waiting Period: 24 Months
                            </span>
                            <span className="font-normal">
                              Initial Waiting Period: 30 Days
                            </span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                <button
                  className={`w-full flex flex-row justify-between items-center ${
                    activeChildTab === "eligibility"
                      ? " text-[#27506E]"
                      : "text-[#181818] hover:text-[#27506E]"
                  }`}
                  onClick={() => toggleChildTab("eligibility")}
                >
                  Eligibility
                  {activeChildTab === "eligibility" ? (
                    <img src={minusSvg} alt="minus" />
                  ) : (
                    <img src={plusSvg} alt="plus" />
                  )}
                </button>
                {activeChildTab === "eligibility" ? (
                  ""
                ) : (
                  <div className="h-[1px] w-full bg-black opacity-40" />
                )}
                {activeChildTab === "eligibility" && (
                  <div className="bg-[#F7F7F7] p-8 rounded-[32px] flex flex-col gap-8">
                    <div className="flex flex-col gap-8">
                      <ul id="health-insurance" className="list-none p-0 m-0">
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Min Entry Age
                            <br />
                            <span className="font-normal">
                              Child - 91 days, Adult - 18 years
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Cover Type
                            <br />
                            <span className="font-normal">
                              Individual/Multi-individual and family floater
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Max Entry Age
                            <br />
                            <span className="font-normal">
                              No Limit (Dependent Children up to the age of 30
                              years can be covered under the family floater
                              plan)
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Policy Period
                            <br />
                            <span className="font-normal">
                              1, 2 and 3 years
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Relationships covered
                            <br />
                            <span className="font-normal">
                              Self, Spouse, Live-in partner, Children, Father,
                              Mother, Father-in-law, Mother-in-law, Son-in-law,
                              Daughter-in-law, Grand-parents, Grandchildren,
                              Uncle, Aunt, Nephew, Niece, Brother, Sister,
                              Sister in-law, Brother in-law
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start mb-8">
                          <span className="w-2 h-2 bg-[#0B497A] rounded-full mt-2 mr-4 flex-shrink-0"></span>
                          <p className="text-black font-semibold text-sm leading-[22px]">
                            Premium Payment Mode
                            <br />
                            <span className="font-normal">
                              Single, Half yearly, Quarterly, Monthly.
                            </span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <p className="pt-4 text-black opacity-70 text-xs leading-[22px]">
          *The Premium value is indicative for the below mentioned profile Age -
          25, Zone - 4, Cover type - Individual (1A), Tenure- 1 year, Premium
          payment mode- Single. Proposal may be subject to underwriting review
        </p>
        {/* Added Download Brochure and UIN and Launch Date */}
        <div className="flex flex-col justify-center items-center mt-10 gap-8">
          <div className="flex flex-row gap-4 text-center pt-1 text-black opacity-70 text-xs leading-[22px]">
            <p>UIN: MCIHLIP26038V022526</p>
            <p>Launch Date: 10-11-2025</p>
          </div>
          <a
            href={mchiSarvahPdf}
            target="_blank"
            rel="noopener noreferrer"
            download
            className="text-[#FB7C2F] text-xl flex flex-row items-center gap-1 p-4 border border-[#FB7C2F] rounded-xl"
          >
            <img src={downloadSvg} alt="download" />
            Download Brochure
          </a>
        </div>
      </div>
    </div>
  );
};

export default HealthInsuranceMobile;
